import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchBar as RSKSearchBar } from '@uncinc/react-searchkit';
import { SearchBarProps as Type } from '@uncinc/react-searchkit/dist/components/SearchBar';

import { SCREEN_WIDE } from '../../../config/constants';
import Button from '../../Button';

import './style.scss';

export interface SearchBarProps extends Type {
  type?: 'primary' | 'secondary';
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = (props) => {
  const {
    type = 'primary',
    placeholder,
    buttonText,
    className,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const classNames = c(`SearchBar--${type}`, className);
  const isSmallScreen = useMemo(() => width < SCREEN_WIDE, [width]);
  const isMobileDesign = type === 'secondary' || isSmallScreen;

  return (
    <RSKSearchBar
      {...restProps}
      className={classNames}
      placeholder={isSmallScreen ? t('components.search.search_bar.mobile_placeholder') : placeholder}
      // eslint-disable-next-line react/no-unstable-nested-components
      button={(buttonProps) => (
        <Button
          {...buttonProps}
          {...(isMobileDesign ? {
            icon: 'search',
            variant: 'icon-only',
            ariaLabel: buttonText || t('buttons.search'),
          } : {})}
        >
          {!isMobileDesign && (buttonText || t('buttons.search'))}
        </Button>
      )}
    />
  );
};

export default SearchBar;
